<footer class="main-footer">
    <div class="container" style="text-align: center;">
      <strong>©{{CurrYear}} Ernst & Young LLP All rights reserved. For internal use only.</strong>
    </div>
</footer>
